import BaseIcon, { IconProps } from '@/components/icons/base-icon';

const SignIconSvg = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox='0 0 21 20'
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.4562 0.755939C16.1374 0.0627688 17.2538 0.0578998 17.9413 0.745465L19.7533 2.55746C20.4414 3.2455 20.4354 4.36049 19.7433 5.04216L13.1429 11.5345C13.0027 11.6725 12.8138 11.7498 12.617 11.7498H9.5C9.08579 11.7498 8.75 11.414 8.75 10.9998V7.88279C8.75 7.68607 8.8273 7.49721 8.96523 7.35694L15.4562 0.755939ZM16.8807 1.80612C16.7823 1.70778 16.6229 1.70882 16.526 1.80737L10.25 8.18977V10.2498H12.31L18.6907 3.97343C18.7904 3.87508 18.7906 3.71603 18.6927 3.61812L16.8807 1.80612Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.75 12.9998C0.75 11.4806 1.98079 10.2498 3.5 10.2498H5.5C5.91421 10.2498 6.25 10.5856 6.25 10.9998C6.25 11.414 5.91421 11.7498 5.5 11.7498H3.5C2.80921 11.7498 2.25 12.309 2.25 12.9998C2.25 13.6906 2.80921 14.2498 3.5 14.2498H17.5C19.0192 14.2498 20.25 15.4806 20.25 16.9998C20.25 18.519 19.0192 19.7498 17.5 19.7498H13.5C13.0858 19.7498 12.75 19.414 12.75 18.9998C12.75 18.5856 13.0858 18.2498 13.5 18.2498H17.5C18.1908 18.2498 18.75 17.6906 18.75 16.9998C18.75 16.309 18.1908 15.7498 17.5 15.7498H3.5C1.98079 15.7498 0.75 14.519 0.75 12.9998Z'
      fill='currentColor'
    />
  </svg>
);

export default function SignIcon(props: IconProps) {
  return <BaseIcon {...props} Icon={SignIconSvg} />;
}
